module.exports = __webpack_public_path__ + "img/_parked.24d0f105.svg";